import React from 'react';
import PropTypes from 'prop-types';
import PackageDetails from '../../components/multi-package-list/package-details';
import * as ShipmentDetailsHelper from '../../components/shipment-details/shipment-details-helper';
import get from 'lodash.get';
import { defineMessages, FormattedMessage } from 'react-intl';
import style from './multi-package-list.module.less';
import { emptyArray } from 'ui-components/default-props/empty';

const messages = defineMessages({
  package: {
    description: 'shipmentDetails.package',
    defaultMessage: 'Package {packageNumber}',
    id: 'V4m+Ha',
  },
});

const multiPackageDetailsProps = (packageData, ordinal) => {
  const insuranceCost = ShipmentDetailsHelper.formatCurrency(get(packageData, 'insuredValue'));
  const dimensions = ShipmentDetailsHelper.formatDimensions(packageData.dimensions);
  const weight = ShipmentDetailsHelper.formatWeight(packageData.weight);

  return {
    header: <FormattedMessage {...messages.package} values={{ packageNumber: ordinal + 1 }} />,
    packageType: get(packageData, 'packageTypeName'),
    weight,
    dimensions,
    insuranceCost,
  };
};

const MultiPackageList = ({ packages = emptyArray }) => {
  return packages.map((packageData, index) => {
    return (
      <div key={index} className={style.package}>
        <PackageDetails {...multiPackageDetailsProps(packageData, index)} />
      </div>
    );
  });
};

MultiPackageList.propTypes = {
  packages: PropTypes.array,
};

export default MultiPackageList;
